(function () {
  'use strict';

  function selectedVariant(card) {
    return card.querySelector('[data-card-variant]:checked') || card.querySelector('[data-card-variant-input]');
  }

  function selectedPlan(card) {
    var select = card.querySelector('[data-card-plan-select]');
    return select && select.options.length ? select.options[select.selectedIndex] : null;
  }

  function syncPlans(card, variantControl) {
    var purchaseOptions = card.querySelector('[data-card-purchase-options]');
    var subscriptionOption = card.querySelector('[data-card-subscription-option]');
    var planSelect = card.querySelector('[data-card-plan-select]');
    var selectWrap = card.querySelector('[data-card-plan-select-wrap]');
    var template = Array.prototype.find.call(
      card.querySelectorAll('[data-card-plan-template]'),
      function (item) { return item.dataset.variantId === variantControl.value; }
    );
    var keepSubscription = subscriptionOption.checked;
    var previousPlanId = planSelect.value;

    planSelect.innerHTML = '';
    if (template) planSelect.appendChild(template.content.cloneNode(true));
    if (previousPlanId) {
      Array.prototype.some.call(planSelect.options, function (option) {
        if (option.value !== previousPlanId) return false;
        option.selected = true;
        return true;
      });
    }
    if (window.jQuery && window.jQuery(planSelect).data('select2')) {
      window.jQuery(planSelect).trigger('change.select2');
    }

    var hasPlans = planSelect.options.length > 0;
    purchaseOptions.classList.toggle('is-hidden', !hasPlans);
    subscriptionOption.disabled = !hasPlans;
    selectWrap.classList.toggle('is-hidden', planSelect.options.length < 2);

    if (!hasPlans || !keepSubscription) {
      card.querySelector('[data-card-purchase-option][value="one-time"]').checked = true;
    } else {
      subscriptionOption.checked = true;
    }
  }

  function renderCardState(card) {
    var variantControl = selectedVariant(card);
    var variantInput = card.querySelector('[data-card-variant-input]');
    var subscriptionOption = card.querySelector('[data-card-subscription-option]');
    var sellingPlanInput = card.querySelector('[data-card-selling-plan-input]');
    var plan = selectedPlan(card);
    var useSubscription = Boolean(subscriptionOption.checked && plan);
    var price = card.querySelector('[data-card-price]');
    var comparePrice = card.querySelector('[data-card-compare-price]');
    var unitPrice = card.querySelector('[data-card-unit-price]');
    var addButton = card.querySelector('[data-card-add]');
    var addLabel = card.querySelector('[data-card-add-label]');
    var subscriptionLabel = card.querySelector('[data-card-subscription-label]');
    var subscriptionPrice = card.querySelector('[data-card-subscription-price]');
    var oneTimePrice = card.querySelector('[data-card-one-time-price]');
    var standardPrice = variantControl.dataset.price;
    var available = variantControl.dataset.available === 'true';

    variantInput.value = variantControl.value;
    variantInput.dataset.price = variantControl.dataset.price;
    variantInput.dataset.comparePrice = variantControl.dataset.comparePrice || '';
    variantInput.dataset.unitPrice = variantControl.dataset.unitPrice || '';
    variantInput.dataset.available = variantControl.dataset.available;

    oneTimePrice.textContent = standardPrice;
    if (plan) {
      var discount = parseInt(plan.dataset.discount, 10) || 0;
      subscriptionLabel.textContent = discount > 0 ? 'Subscribe & Save ' + discount + '%' : 'Subscribe & Save';
      subscriptionPrice.textContent = plan.dataset.price;
    }

    price.textContent = useSubscription ? plan.dataset.price : standardPrice;
    comparePrice.textContent = useSubscription ? standardPrice : (variantControl.dataset.comparePrice || '');
    comparePrice.classList.toggle('is-hidden', useSubscription ? plan.dataset.price === standardPrice : !variantControl.dataset.comparePrice);
    unitPrice.textContent = variantControl.dataset.unitPrice || '';
    unitPrice.classList.toggle('is-hidden', !variantControl.dataset.unitPrice);

    sellingPlanInput.value = useSubscription ? plan.value : '';
    sellingPlanInput.disabled = !useSubscription;
    addButton.disabled = !available;
    addLabel.textContent = available ? 'Add to cart' : 'Sold out';

    card.querySelector('[data-card-plan-select-wrap]').classList.toggle(
      'is-hidden',
      !useSubscription || card.querySelector('[data-card-plan-select]').options.length < 2
    );

    card.querySelector('.klampet-product-card__form').dispatchEvent(
      new CustomEvent('klampet:variant-change', { bubbles: true })
    );
  }

  function updateVariant(card, variantControl) {
    syncPlans(card, variantControl);
    renderCardState(card);
  }

  function initializeCard(card) {
    if (card.dataset.klampetProductCardReady === 'true') return;
    card.dataset.klampetProductCardReady = 'true';

    card.addEventListener('click', function (event) {
      var interactiveSelector = 'a, button, input, label, select, textarea, [role="button"], .klampet-product-card__reviews, .spr-badge';
      var selection = window.getSelection && window.getSelection();

      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.target.closest(interactiveSelector) ||
        (selection && selection.toString().length > 0)
      ) return;

      if (event.metaKey || event.ctrlKey) {
        window.open(card.dataset.cardUrl, '_blank', 'noopener');
      } else {
        window.location.assign(card.dataset.cardUrl);
      }
    });

    card.querySelectorAll('[data-card-variant]').forEach(function (control) {
      control.addEventListener('change', function () { updateVariant(card, control); });
    });

    card.querySelectorAll('[data-card-purchase-option]').forEach(function (control) {
      control.addEventListener('change', function () { renderCardState(card); });
    });

    card.querySelector('[data-card-plan-select]').addEventListener('change', function () {
      renderCardState(card);
    });

    updateVariant(card, selectedVariant(card));
  }

  function initializeAll(root) {
    root.querySelectorAll('[data-klampet-product-card]').forEach(initializeCard);
  }

  document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-klampet-product-card]')) initializeCard(node);
        initializeAll(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}());
